/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_DesktopInputs */

const en_downloads_dropdown_desktop = /** @type {(inputs: Downloads_Dropdown_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop`)
};

const es_downloads_dropdown_desktop = /** @type {(inputs: Downloads_Dropdown_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritorio`)
};

/**
* | output |
* | --- |
* | "Desktop" |
*
* @param {Downloads_Dropdown_DesktopInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_desktop = /** @type {((inputs?: Downloads_Dropdown_DesktopInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_DesktopInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_desktop(inputs)
	return en_downloads_dropdown_desktop(inputs)
});